import type { DropdownProps } from "semantic-ui-react";
import type { UsersRole } from "./users.types";
// Type definitions for IMPORT DATA (USERS | ROTATIONS):
// GENERAL:
type ImportDataModelUsers = UsersRole;
type ImportDataModelRotations = "Rotations";
export const TENANT_SETTINGS_IMPORT_MODELS = [
  "CaseLogsSettingsLanguages",
  "CaseLogsSettingsInsurances",
  "CaseLogsSettingsRaces",
  "CaseLogsSettingsReasonsForVisit",
  "CaseLogsSettingsDisciplinesDiagnostics",
  "CaseLogsSettingsDisciplinesProcedures",
  "CaseLogsSettingsToothList",
] as const;
export type TenantSettingsImportModel =
  typeof TENANT_SETTINGS_IMPORT_MODELS[number];
export type TypeImportData =
  | ImportDataModelUsers
  | ImportDataModelRotations
  | TenantSettingsImportModel;
export type ImportDataGroup = "Users" | "Rotations" | "TenantSettings";
export type ImportDataCollection = "users" | "rotations" | "tenantSettings";
export const getImportDataGroupCollection = (
  group: ImportDataGroup
): ImportDataCollection =>
  group === "TenantSettings"
    ? "tenantSettings"
    : (group.toLowerCase() as ImportDataCollection);
export const isTenantSettingsImportModel = (
  model: TypeImportData | string
): model is TenantSettingsImportModel =>
  TENANT_SETTINGS_IMPORT_MODELS.includes(model as TenantSettingsImportModel);
export const getImportDataCollection = (
  model: TypeImportData
): ImportDataCollection =>
  model === "Rotations"
    ? "rotations"
    : isTenantSettingsImportModel(model)
    ? "tenantSettings"
    : "users";
type ImportDataCommons = {
  goTo: (
    onGoTo: "closeImport" | "statusImport" | "generateCSVImport" | ""
  ) => () => void;
  modelSelected: TypeImportData;
  onSelectedData?: (
    event: React.SyntheticEvent<HTMLElement>,
    data: DropdownProps
  ) => void;
  roles?: { key: UsersRole; value: UsersRole; text: string }[];
  typeImport: ImportDataGroup;
};
// ACTIONS:
// REDUCERS:
type Import = {
  data: { [k: string]: any }[];
  lastFetching: number;
  status: "idle" | "fetching" | "ready" | "failed";
};
export type StateImportData = {
  imports: {
    users: Import;
    rotations: Import;
    tenantSettings: Import;
  };
  importDataNotification: {
    toShow: boolean;
    hasErrors: boolean;
    typeImport: TypeImportData | "";
  };
};
// SAGAS:
// COMPONENTS:
// ImportDataContainer:
export type PropsImportDataContainer = ImportDataCommons & {
  showImportStatus: boolean;
};
export type StateImportDataContainer = {
  errors: Array<string>;
  fileToUpload: Array<any>;
  statusUploadingFile: "uploading" | "error" | "success" | "";
  success: Array<string>;
};
// ImportDataView:
export type PropsImportDataView = ImportDataCommons & {
  fileToUpload: StateImportDataContainer["fileToUpload"];
  numFileImporting: number;
  onImportData: (
    fileToUpload: StateImportDataContainer["fileToUpload"]
  ) => () => void;
  onSaveFileToUpload: (
    fileToUpload: StateImportDataContainer["fileToUpload"]
  ) => () => void;
};
export type StateImportDataView = {
  pulseInfo: boolean;
};
// ImportStatus (Container | View):
export type PropsImportStatus = {
  goTo: ImportDataCommons["goTo"];
  importData: StateImportData["imports"][
    | "users"
    | "rotations"
    | "tenantSettings"]["data"];
  isFetching: boolean;
  typeImport: ImportDataCommons["typeImport"];
};
export type StateImportStatusView = {
  errors: any[];
  fileName: string;
  toShow: boolean;
};
// ImportFileError:
export type PropsImportFileError = StateImportStatusView & {
  onClose: () => void;
  typeImport: ImportDataCommons["typeImport"];
};
// ImportDataNotificationView:
export type PropsImportDataNotificationView = {
  onGoToImportStatus: () => void;
};
